// extracted by mini-css-extract-plugin
module.exports = {"root":"az_Bhb","text":"az_Chb","pulse":"az_Dhb","wave":"az_Ehb"};